import { useState, useCallback } from 'react';
import { handleDismissTileForUserProfile } from '../../../../Account/Profile/util/tiles';
import { analyticsTrackEvent } from '../../../../../core/analytics';
import { ACTION_DISMISS_TILE, PROFILE_DISCOVER } from '../../../../../core/analytics/events';

export default () => {
  const [numberTilesDismissed, setNumberTilesDismissed] = useState(0);

  return useCallback(
    (tileId, userProfile) => {
      handleDismissTileForUserProfile(tileId, userProfile);
      setNumberTilesDismissed((prev) => prev + 1);
      analyticsTrackEvent(PROFILE_DISCOVER, {
        action: ACTION_DISMISS_TILE,
        tileId,
      });
    },
    [setNumberTilesDismissed]
  );
};
